export default __webpack_public_path__ + "assets/wasm/basis_transcoder-c04c5112870b4791e3925f3b4c94c752.wasm";